import React from 'react'
import RichText from '../components/Blog/RichText'
import ImageSlider from '../components/Blog/ImageSlider'
import Quote from '../components/Blog/Quote'
import Media from '../components/Blog/Media'
import Cta from '../components/Blog/Cta'

/**
 * Renders different content blocks based on Strapi component type
 * @param {Object} section - The content block from Strapi
 * @param {number} index - Index for React key
 * @returns {JSX.Element|null} - Rendered component or null
 */
export function blockRenderer(section, index) {
    if (!section) {
        return null
    }

    const componentType = section.type || section.__component

    if (!componentType) {
        return null
    }

    switch (componentType) {
        case 'rich_text':
        case 'shared.rich-text':
            return <RichText key={index} data={section} />

        case 'shared.slider':
            return <ImageSlider key={index} data={section} />

        case 'shared.quote':
            return <Quote key={index} data={section} />

        case 'media':
        case 'shared.media':
            return <Media key={index} data={section} />

        case 'cta':
        case 'shared.cta':
            return <Cta key={index} data={section} />

        default:
            console.warn(`Unknown component type: ${componentType}`)
            return null
    }
}

export default blockRenderer
